export function PreviousNextView(props) {
  return props.children;
}

export default {
  setKeyboardDistanceFromTextField(distance) {},
};
